import { I18n } from '@calendly/i18n'

import { summarizeAvailabilityRule } from 'components/event_type_edit'

const EN_DASH = '\u2013'

/**
 * Figma schedule subtext: "Mon – Fri, 9 am – 5 pm" (not "Weekdays, 09:00 - 17:00").
 * Always format times in 12h — design uses am/pm even when the user preference is 24h.
 */
export const formatV4ScheduleSummary = (schedule) => {
  const summary = summarizeAvailabilityRule(schedule, '12h')
  if (!summary) return ''

  const weekdaysLabel = I18n.t('publisher.event_type_editor.sections.scheduling_settings.summary.weekdays')
  const abbreviatedDayNames = I18n.t('publisher.organization.reporting.abbreviated_day_names')
  const monFriLabel = `${abbreviatedDayNames[0]} ${EN_DASH} ${abbreviatedDayNames[4]}`

  return summary
    .replace(weekdaysLabel, monFriLabel)
    .replace(/ - /g, ` ${EN_DASH} `)
}
